import {createUseStyles} from 'react-jss';
import {HiddenRadioStyles} from '../../components/RadioOverlay/RadioOverlay';
import FieldTypes from '../../enums/FieldTypes';
import loadArtemisFonts from '../components/ui/loadArtemisFonts';
import Spacing from '../style-helper/Spacing';
import Typography from '../style-helper/Typography';
import Width from '../style-helper/Width';
import baseInputStyles from './Form.styles';

export default createUseStyles({
  inputField: props => ({
    ...baseInputStyles,
    ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
      && loadArtemisFonts(props.theme?.typography[Typography.body],
        props.theme.button.isBold),
    extend: {...props.definedField.type === 'radio' && HiddenRadioStyles(props)},
    
    // Hide in built browser clear input button on search input types
    '& input[type="search"]::-webkit-search-cancel-button': {
      display: 'none',
    },
    '& input[type="search"]::-ms-clear': {
      display: 'none',
      width: Width.zero,
      height: 0,
    },
  }),
  inputContainer: {
    display: 'flex',
    width: Width.full,
    position: 'relative',
  },
  iconWrapper: {
    display: 'flex',
    position: 'absolute',
    height: '100%',
    right: (props) => {
      if (props.isCollection) {
        return 100;
      }
      
      return (props.definedField.name !== 'LoqateAddressLookup' && !props.isRightToLeft) && 0;
    },
    left: props => props.isRightToLeft && 0,
  },
  clearInput: {
    order: 0,
    padding: 0,
    right: (props) => {
      if (props.fieldType === FieldTypes.AUTOCOMPLETE) {
        if (props.isCollection) {
          if (props.shouldUseNewCollectionOverlay && !props.isOverlay) {
            return props.isMobile ? 45 : 185;
          }
          return 5;
        }
        return 44;
      }
      
      return 44;
    },
    color: props => props.theme.core.brand,
    
    '& svg': { // Adding background for cleaner look for long values
      background: '#fff',
      borderRadius: '100%',
    },
    
    '&:focus': {
      padding: 0,
    },
  },
  showPasswordIcon: {
    opacity: 0.6,
    order: 1,
    padding: [12, Spacing.half],
  },
  labelOptional: {
    color: '#808080',
    textDecoration: 'underline',
    fontStyle: 'italic',
  },
  infoMessage: {
    padding: [12, 0],
  },
});
